import {  useState } from "react";
import { Modal } from "react-bootstrap";
import _ from "lodash";
import RecallActivity from "../RecallActivity";

const RecallActivityLink = (props: any) => {
  const [isPopupOpened, setIsPopupOpened] = useState<boolean>(false);

  const onLinkClick = async (event: any) => {
    event.preventDefault();
    setIsPopupOpened(true);
  };

  return (
    <div>
      {!props?.data?.isTotalRow && _.isString(props?.value) && (
        <a href="#" onClick={onLinkClick}>
          {" "}
          {props?.value}
        </a>
      )}

      {(props?.data?.isTotalRow || !_.isString(props?.value)) && (
        <div> {props.value}</div>
      )}
      <Modal
        size="lg"
        centered
        show={isPopupOpened}
        onHide={() => setIsPopupOpened(false)}
        backdrop="static"
      >
        <Modal.Header
          style={{
            backgroundColor: "#6a7587",
            color: "#fff",
            height: "3rem",
          }}
          closeButton
        >
          <Modal.Title>
            Recall Activity (
            {props?.node?.aggData?.lender_ref_id && !_.isEmpty(props?.node?.aggData?.lender_ref_id)?(props?.node?.aggData?.lender_ref_id): props?.node?.data?.lender_ref_id}
            /{props?.node?.aggData?.bl && !_.isEmpty(props?.node?.aggData?.bl)?(props?.node?.aggData?.bl): props?.node?.data?.bl})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RecallActivity
            lender_ref_id={(props?.node?.aggData?.lender_ref_id && !_.isEmpty(props?.node?.aggData?.lender_ref_id))?(props?.node?.aggData?.lender_ref_id): props?.node?.data?.lender_ref_id}
          ></RecallActivity>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default RecallActivityLink;
